export default {
    "dynamicFormsDelete_title": "Delete Forms",
    "dynamicFormsDelete_deleteWarning": "Are you sure you want delete the following forms? This action can't be undone",
    "dynamicFormsDelete_success": "Success",
    "dynamicFormsDelete_successMessage": "Forms deleted successfully",
    "dynamicFormsDelete_errorByWorkOrders": "It is not possible to delete forms that are being used in work orders"
}